import { render, staticRenderFns } from "./HomeNewsBox.vue?vue&type=template&id=4a3fbd42&"
import script from "./HomeNewsBox.vue?vue&type=script&lang=js&"
export * from "./HomeNewsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports